import { ETextStyleVariant, GeneralClockIcon, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

import { trackWishlistSelectedEvent } from '@/services/analytics/wishlists';
import { EWishlistSelectedSource } from '@/services/analytics/wishlists/types';
import { IRentalTile } from '@/utility/mapSearchResultToTile';

type TRecentlyViewedCardProps = {
  recentlyViewedTiles: IRentalTile[] | undefined;
  rentalCategory: string;
};

export const WishlistsRecentlyViewedCard = ({
  recentlyViewedTiles,
  rentalCategory,
}: TRecentlyViewedCardProps) => {
  const photoUrl: string | string[] | undefined = recentlyViewedTiles?.[0]?.photoUrl;
  const photoAlt = recentlyViewedTiles?.[0]?.photoAlt || '';
  const firstPhotoUrl = Array.isArray(photoUrl) ? photoUrl[0] : photoUrl;

  // Only count tiles that have viewedUpdated (backend data)
  const backendTilesCount = recentlyViewedTiles?.filter(tile => tile.viewedUpdated).length ?? 0;

  const handleClickRecentlyViewedCard = () => {
    trackWishlistSelectedEvent({
      wishlistID: null,
      wishlistName: 'Recently viewed',
      coverPhotoRentalID: recentlyViewedTiles?.[0]?.id || null,
      wishlistItemCount: backendTilesCount,
      wishlistCreatorID: null,
      source: EWishlistSelectedSource.WISHLIST_MAIN,
      rentalCategory: rentalCategory,
    });
  };

  return (
    <Link
      href="/wishlists/recently-viewed"
      className="block"
      onClick={handleClickRecentlyViewedCard}>
      <div className="flex flex-col w-full gap-2">
        {firstPhotoUrl ? (
          <div className="aspect-square hover:outline outline-2 outline-offset-2 outline-green-500 rounded-2xl">
            <Image
              src={firstPhotoUrl}
              alt={photoAlt}
              width={297}
              height={297}
              className="object-cover w-full h-full rounded-2xl"
            />
          </div>
        ) : (
          <div className="flex items-center justify-center aspect-square rounded-2xl bg-[#F1F2F3] hover:outline outline-2 outline-offset-2 outline-green-500">
            <GeneralClockIcon fontSize={48} className="text-gray-310" />
          </div>
        )}
        <div className="flex flex-col">
          <Text variant={ETextStyleVariant.MediumBold}>
            <FormattedMessage defaultMessage="Recently viewed" id="MSvvwO" />
          </Text>
          <Text variant={ETextStyleVariant.SmallRegular}>
            <FormattedMessage
              defaultMessage="{count} saved"
              id="SI6P08"
              values={{ count: backendTilesCount }}
            />
          </Text>
        </div>
      </div>
    </Link>
  );
};
